var _defs, _path, _path2, _polygon, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g, _path46, _g2, _path47, _g3, _path48, _polygon2, _g4, _path49, _g5, _path50, _path51, _path52, _g6, _g7, _path53, _g8, _path54, _g9, _circle, _g10, _path55, _path56, _g11, _circle2, _circle3, _circle4, _rect46, _rect47, _g12, _rect48, _rect49, _ellipse;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSideimg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a1e1094a-0c8c-49ef-9e46-7b691cb0c375",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 955,
    height: 680.5,
    viewBox: "0 0 955 680.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "24f03e8c-5c7e-4fae-8483-b5d808403054",
    x1: 410.65,
    y1: 444.9,
    x2: 677,
    y2: 444.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "00c9c3cb-352a-4ad1-9ec3-c89fe8d1d33c",
    x1: 518.88,
    y1: 466.38,
    x2: 520.07,
    y2: 466.38,
    xlinkHref: "#24f03e8c-5c7e-4fae-8483-b5d808403054"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "120917fe-dde0-4ef5-b791-4b8cdc7eaea0",
    x1: 519.81,
    y1: 467.31,
    x2: 521.01,
    y2: 467.31,
    xlinkHref: "#24f03e8c-5c7e-4fae-8483-b5d808403054"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d6588c0b-28b1-4044-81f0-862b52dadcf0",
    x1: 519.81,
    y1: 466.38,
    x2: 521.01,
    y2: 466.38,
    xlinkHref: "#24f03e8c-5c7e-4fae-8483-b5d808403054"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "walk in the city") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-10.73,747.34",
    transform: "translate(-122.5 -109.75)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M980.07,687.7c-7.12,3.67-14.58,6.84-21.94,10-27.19,11.48-54.79,23.06-84,27C819.27,732,762.66,712,708.76,724.48c-45.15,10.42-82.49,42.35-126.6,56.57-20.51,6.61-41.85,9.2-63.38,9.2H516q-4-.05-7.94-.2c-21.83-.82-43.75-4.05-65.15-8.18-67.57-13-136.34-36.83-188-80.7C405.33,673.69,715.18,631.51,980.07,687.7Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#252223",
    opacity: 0.1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "910 249 910 185 872 185 872 249 827 249 827 150 794 150 794 76 767 76 767 0 711 0 711 76 684 76 684 150 652 150 652 61 634 61 634 16 623 16 623 61 559 61 559 345 510 345 510 315 480 315 480 345 431 345 431 249 343 249 343 185 305 185 305 249 303 249 303 372 263 372 263 300 215 300 215 372 175 372 175 150 144 150 144 76 30 76 30 150 0 150 0 541 175 541 303 541 431 541 559 541 652 541 827 541 955 541 955 249 910 249",
    fill: "#eba399",
    opacity: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 173,
    width: 42,
    height: 24,
    fill: "#fff",
    opacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 235.5,
    y: 282.75,
    width: 42,
    height: 24,
    transform: "translate(390.5 479.75) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 220,
    width: 42,
    height: 24,
    fill: "#fff",
    opacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 235.5,
    y: 329.75,
    width: 42,
    height: 24,
    transform: "translate(390.5 573.75) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 267,
    width: 42,
    height: 24,
    fill: "#fff",
    opacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 235.5,
    y: 376.75,
    width: 42,
    height: 24,
    transform: "translate(390.5 667.75) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 314,
    width: 42,
    height: 24,
    fill: "#fff",
    opacity: 0.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 235.5,
    y: 423.75,
    width: 42,
    height: 24,
    transform: "translate(390.5 761.75) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 361,
    width: 42,
    height: 24,
    fill: "#fff",
    opacity: 0.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 235.5,
    y: 470.75,
    width: 42,
    height: 24,
    transform: "translate(390.5 855.75) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 408,
    width: 42,
    height: 24,
    fill: "#fff",
    opacity: 0.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 235.5,
    y: 517.75,
    width: 42,
    height: 24,
    transform: "translate(390.5 949.75) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 455,
    width: 42,
    height: 24,
    fill: "#fff",
    opacity: 0.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 235.5,
    y: 564.75,
    width: 42,
    height: 24,
    transform: "translate(390.5 1043.75) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 396,
    width: 98,
    height: 12,
    fill: "#fff",
    opacity: 0.4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 414,
    width: 98,
    height: 12,
    fill: "#fff",
    opacity: 0.4
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 432,
    width: 98,
    height: 12,
    fill: "#fff",
    opacity: 0.4
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 402,
    width: 98,
    height: 12,
    fill: "#fff",
    opacity: 0.4
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 420,
    width: 98,
    height: 12,
    fill: "#fff",
    opacity: 0.4
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 446,
    y: 438,
    width: 98,
    height: 12,
    fill: "#fff",
    opacity: 0.4
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 450,
    width: 98,
    height: 12,
    fill: "#fff",
    opacity: 0.4
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 468,
    width: 98,
    height: 12,
    fill: "#fff",
    opacity: 0.4
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 486,
    width: 98,
    height: 12,
    fill: "#fff",
    opacity: 0.4
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 272,
    width: 27,
    height: 35,
    fill: "#fff",
    opacity: 0.4
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 505.5,
    y: 381.75,
    width: 27,
    height: 35,
    transform: "translate(915.5 688.75) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 328,
    width: 27,
    height: 35,
    fill: "#fff",
    opacity: 0.4
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 505.5,
    y: 437.75,
    width: 27,
    height: 35,
    transform: "translate(915.5 800.75) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 384,
    width: 27,
    height: 35,
    fill: "#fff",
    opacity: 0.4
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 505.5,
    y: 493.75,
    width: 27,
    height: 35,
    transform: "translate(915.5 912.75) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 440,
    width: 27,
    height: 35,
    fill: "#fff",
    opacity: 0.4
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 505.5,
    y: 549.75,
    width: 27,
    height: 35,
    transform: "translate(915.5 1024.75) rotate(-180)",
    fill: "#fff",
    opacity: 0.4
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 84,
    width: 36,
    height: 46,
    fill: "#fff",
    opacity: 0.4
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 150,
    width: 36,
    height: 46,
    fill: "#fff",
    opacity: 0.4
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 216,
    width: 36,
    height: 46,
    fill: "#fff",
    opacity: 0.4
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 282,
    width: 36,
    height: 46,
    fill: "#fff",
    opacity: 0.4
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 348,
    width: 36,
    height: 46,
    fill: "#fff",
    opacity: 0.4
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 559,
    y: 414,
    width: 36,
    height: 46,
    fill: "#fff",
    opacity: 0.4
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 672.5,
    y: 178,
    width: 134,
    height: 39,
    fill: "#fff",
    opacity: 0.4
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 673,
    y: 262,
    width: 134,
    height: 39,
    fill: "#fff",
    opacity: 0.4
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 673.5,
    y: 346,
    width: 134,
    height: 39,
    fill: "#fff",
    opacity: 0.4
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 674,
    y: 430,
    width: 134,
    height: 39,
    fill: "#fff",
    opacity: 0.4
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 97,
    width: 18,
    height: 38,
    fill: "#fff",
    opacity: 0.4
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 910,
    y: 272,
    width: 45,
    height: 58,
    fill: "#fff",
    opacity: 0.4
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 910,
    y: 356,
    width: 45,
    height: 58,
    fill: "#fff",
    opacity: 0.4
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 910,
    y: 440,
    width: 45,
    height: 58,
    fill: "#fff",
    opacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.17,589.3S93.44,636.8,238.57,709.93c0,0,32-59.36-3.38-107.76a47.66,47.66,0,0,0-61.83-13.55Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.08,588.3s67.37,51.55,65.49,121.63",
    transform: "translate(-122.5 -109.75)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M242.23,712.63s-24.67-83.76,4.63-145.41c12.3-25.87,16.38-54.92,10.7-83a222.5,222.5,0,0,0-11.75-39",
    transform: "translate(-122.5 -109.75)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M264,406.31c0,10.27-18.59,40-18.59,40s-18.59-29.77-18.59-40a18.59,18.59,0,1,1,37.17,0Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M294.76,463.17c-5.58,8.62-37.36,23.5-37.36,23.5s.58-35.09,6.16-43.71a18.59,18.59,0,0,1,31.2,20.2Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M293.41,560.34c-9.17,4.62-44.11,1.43-44.11,1.43s18.21-30,27.38-34.62a18.59,18.59,0,0,1,16.74,33.19Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M275.84,633.63c-8.25,6.1-43.24,8.86-43.24,8.86s12.88-32.64,21.13-38.75a18.59,18.59,0,1,1,22.11,29.89Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M218.37,488.66c7.36,7.15,41.67,14.56,41.67,14.56s-8.4-34.07-15.76-41.23a18.59,18.59,0,1,0-25.9,26.66Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M198.91,574.63c9.17,4.62,44.11,1.43,44.11,1.43s-18.21-30-27.38-34.62a18.59,18.59,0,0,0-16.74,33.19Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M191.46,660.79c8.25,6.1,43.24,8.86,43.24,8.86S221.82,637,213.56,630.9a18.59,18.59,0,0,0-22.11,29.89Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M264,406.31c0,10.27-18.59,40-18.59,40s-18.59-29.77-18.59-40a18.59,18.59,0,1,1,37.17,0Z",
    transform: "translate(-122.5 -109.75)",
    opacity: 0.25
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M294.76,463.17c-5.58,8.62-37.36,23.5-37.36,23.5s.58-35.09,6.16-43.71a18.59,18.59,0,0,1,31.2,20.2Z",
    transform: "translate(-122.5 -109.75)",
    opacity: 0.25
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M293.41,560.34c-9.17,4.62-44.11,1.43-44.11,1.43s18.21-30,27.38-34.62a18.59,18.59,0,0,1,16.74,33.19Z",
    transform: "translate(-122.5 -109.75)",
    opacity: 0.25
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M275.84,633.63c-8.25,6.1-43.24,8.86-43.24,8.86s12.88-32.64,21.13-38.75a18.59,18.59,0,1,1,22.11,29.89Z",
    transform: "translate(-122.5 -109.75)",
    opacity: 0.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M218.37,488.66c7.36,7.15,41.67,14.56,41.67,14.56s-8.4-34.07-15.76-41.23a18.59,18.59,0,1,0-25.9,26.66Z",
    transform: "translate(-122.5 -109.75)",
    opacity: 0.25
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M198.91,574.63c9.17,4.62,44.11,1.43,44.11,1.43s-18.21-30-27.38-34.62a18.59,18.59,0,0,0-16.74,33.19Z",
    transform: "translate(-122.5 -109.75)",
    opacity: 0.25
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M191.46,660.79c8.25,6.1,43.24,8.86,43.24,8.86S221.82,637,213.56,630.9a18.59,18.59,0,0,0-22.11,29.89Z",
    transform: "translate(-122.5 -109.75)",
    opacity: 0.25
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.28,691s-24.67-83.76,4.63-145.41c12.3-25.87,16.38-54.92,10.7-83a222.5,222.5,0,0,0-11.75-39",
    transform: "translate(-122.5 -109.75)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.09,384.68c0,10.27-18.59,40-18.59,40s-18.59-29.77-18.59-40a18.59,18.59,0,1,1,37.17,0Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1064.81,441.54c-5.58,8.62-37.36,23.5-37.36,23.5s.58-35.09,6.16-43.71a18.59,18.59,0,1,1,31.2,20.2Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1063.47,538.71c-9.17,4.62-44.11,1.43-44.11,1.43s18.21-30,27.38-34.62a18.59,18.59,0,0,1,16.74,33.19Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.9,612c-8.25,6.1-43.24,8.86-43.24,8.86s12.88-32.64,21.13-38.75A18.59,18.59,0,0,1,1045.9,612Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M988.42,467c7.36,7.15,41.67,14.56,41.67,14.56s-8.4-34.07-15.76-41.23A18.59,18.59,0,0,0,988.42,467Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M969,553c9.17,4.62,44.11,1.43,44.11,1.43s-18.21-30-27.38-34.62A18.59,18.59,0,0,0,969,553Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M961.51,639.16c8.25,6.1,43.24,8.86,43.24,8.86s-12.88-32.64-21.13-38.75a18.59,18.59,0,0,0-22.11,29.89Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M901,682.85s-13.26-45,2.49-78.14a71.09,71.09,0,0,0,5.75-44.6,119.57,119.57,0,0,0-6.31-20.93",
    transform: "translate(-122.5 -109.75)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M912.72,518.23c0,5.52-10,21.51-10,21.51s-10-16-10-21.51a10,10,0,0,1,20,0Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M929.23,548.79c-3,4.63-20.08,12.63-20.08,12.63s.31-18.86,3.31-23.49a10,10,0,1,1,16.77,10.86Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M928.51,601c-4.93,2.48-23.71.77-23.71.77s9.79-16.12,14.71-18.6a10,10,0,0,1,9,17.84Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M919.06,640.39c-4.44,3.28-23.24,4.76-23.24,4.76s6.92-17.54,11.36-20.82a10,10,0,0,1,11.88,16.06Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M888.18,562.49c4,3.84,22.39,7.83,22.39,7.83s-4.51-18.31-8.47-22.15a10,10,0,1,0-13.92,14.33Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M877.72,608.69c4.93,2.48,23.71.77,23.71.77s-9.79-16.12-14.71-18.6a10,10,0,0,0-9,17.84Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M873.72,655c4.44,3.28,23.24,4.76,23.24,4.76S890,642.21,885.6,638.93A10,10,0,0,0,873.72,655Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#eba399"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M387.18,157.43H380.3a4.82,4.82,0,1,0,0-9.63H324.57a4.82,4.82,0,0,0,0,9.63h6.88a4.82,4.82,0,1,0,0,9.63h-9.63a4.82,4.82,0,1,0,0,9.63h55.73a4.82,4.82,0,1,0,0-9.63h9.63a4.82,4.82,0,1,0,0-9.63Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#252223",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M633.18,278.43H626.3a4.82,4.82,0,1,0,0-9.63H570.57a4.82,4.82,0,0,0,0,9.63h6.88a4.82,4.82,0,1,0,0,9.63h-9.63a4.82,4.82,0,1,0,0,9.63h55.73a4.82,4.82,0,1,0,0-9.63h9.63a4.82,4.82,0,1,0,0-9.63Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#252223",
    opacity: 0.1
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.18,120.43h-6.88a4.82,4.82,0,1,0,0-9.63H989.57a4.82,4.82,0,0,0,0,9.63h6.88a4.82,4.82,0,1,0,0,9.63h-9.63a4.82,4.82,0,1,0,0,9.63h55.73a4.82,4.82,0,0,0,0-9.63h9.63a4.82,4.82,0,1,0,0-9.63Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#252223",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M670.7,676.43l.22,0S635.83,580,626,566.93c0,0-10.29-6.08-9.82-16.37l-12.63-61.28s.19-.19.51-.54l.27-.3.31-.36a29.35,29.35,0,0,0,4.19-6.59l.2-.46a25.27,25.27,0,0,0,1.18-3.31,3.49,3.49,0,0,0,2.69-.14s0-.33,0-.92h0s-.12-3.63-.13-9.31c0-1.58,0-3.3,0-5.13.39-1.41.72-2.89,1-4.47l-.51-.24,0-.23-.43-.2c.35-13.45,1.49-30.64,4.78-42.35q.17-.62.36-1.23c3.89-12.79,4-28.4,5-41.6a42.42,42.42,0,0,1,2,5.11,7.81,7.81,0,0,1,1.69-1.43l3.92,31.37v37s-6.55,47.72,14,38.83,5.61-41.64,5.61-41.64,0-18.24,2.81-27.6c1.85-6.16.66-26.08-.38-39,2,.35,3.18.63,3.18.63a21.88,21.88,0,0,0,.61-5.73c.43-21.57-26.17-56.32-37-69.58a31.09,31.09,0,0,0-12.49-11l-20.81-10.08s-9.83-2.4-13.66-10c0-.13-.07-.26-.1-.39q.65-.29,1.28-.63a23.06,23.06,0,0,0,8.14-6.54c4.43-5.63,6.55-12.68,8.57-19.55,2.38-8.08,4.78-16.33,4.46-24.75s-3.86-17.17-11-21.64c-6.1-3.82-14.61-4.54-18.4-10.66-1-1.65-1.64-3.61-3-4.94a1.14,1.14,0,0,0-.92-1.18L551,176.44a1.14,1.14,0,0,0-1.34.9l0,.15a63.38,63.38,0,0,0-26.93,6.84,61.28,61.28,0,0,0-8.52,5c-3.85,2.72-7.64,6.33-8.19,11-.27,2.33.29,4.72-.18,7-1.27,6.11-9.46,10.09-8.26,16.22.81,4.16,5.52,5.95,9.93,6a33.22,33.22,0,0,0,25.25,41.48,95.94,95.94,0,0,1,8.4,14.3c-5.39,5.12-16.68,17-9.76,21L517,341.91l1.4,36.67L512.33,384l1.33,1.66c-6.8,7.92-22.54,25.23-34.05,29.84a35.58,35.58,0,0,0-4.8,2.36,19.37,19.37,0,0,1-6.89,2.7,19,19,0,0,0-3.16.62l-2.75-5.7a4.1,4.1,0,0,0-5.48-1.91l-1.69.81h0l-4,1.93-1.67.81h0l-1.26.61A4.1,4.1,0,0,0,446,423.2l3.33,6.9c-4.73,4.17-7.05,9.15-.6,13.79a14,14,0,0,0,8.55,2.7l2,4.19a4.1,4.1,0,0,0,5.48,1.91l2.93-1.42,5.68-2.74a4.1,4.1,0,0,0,1.91-5.48l-1.66-3.45a67.68,67.68,0,0,0,10.16-9.75s8.54-5.35,13.57-6.55c3.33-.79,15-8.46,22.24-13.32l2.06,54a11.46,11.46,0,0,1-1.58,1.94l1.61-1.14,0,.4a8.91,8.91,0,0,1-.69.74l.7-.5,0,.65a9,9,0,0,1-.73.78l.74-.52L522,472l3.52-5.84.22,5.84.82-1.36c-9.88,16.79-22.75,41.51-29.63,66.38,0,0-10.76,18.71-9.36,37.89l-19.65,95,.38.14c-6.4,4.62-19.89,13.09-33.12,13.43,0,0-31.81-.94-22.92,6.08s87.95,17.31,87.95,17.31l3-23.65.7.26s0-.13,0-.37l1,.37S503,671.72,510,665.17s23.39-73,22-83.27c0,0,12.56-31.39,28.28-56.42L578.76,573l20.58,35.55s27.38,60.88,26.5,74.44c-5.75,7-16,18-23.69,17.71,0,0-31.34,6.08-9.82,11.7S677,697,677,697Zm-137-217.66.19-.11c-1,1.51-2,3.18-3.14,5Z",
    transform: "translate(-122.5 -109.75)",
    fill: "url(#24f03e8c-5c7e-4fae-8483-b5d808403054)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M520.07,465.94c-.77.56-1.19.87-1.19.87A5.07,5.07,0,0,0,520.07,465.94Z",
    transform: "translate(-122.5 -109.75)",
    fill: "url(#00c9c3cb-352a-4ad1-9ec3-c89fe8d1d33c)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M521,466.88c-.77.56-1.19.87-1.19.87A5.07,5.07,0,0,0,521,466.88Z",
    transform: "translate(-122.5 -109.75)",
    fill: "url(#120917fe-dde0-4ef5-b791-4b8cdc7eaea0)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M521,465.94c-.77.56-1.19.87-1.19.87A5.07,5.07,0,0,0,521,465.94Z",
    transform: "translate(-122.5 -109.75)",
    fill: "url(#d6588c0b-28b1-4044-81f0-862b52dadcf0)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M628.05,671.5s-16.42,23.26-27.37,22.8c0,0-30.56,5.93-9.58,11.4s82.55-15.05,82.55-15.05l-7.32-23.85Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#333"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M554.62,510l23.26,59.75L598,604.46s27.59,61.34,25.77,73.2l44-7.07s-34.21-94-43.78-106.72c0,0-10-5.93-9.58-16l-12.31-59.75s12-11.56,5.28-26q-.51-1.11-1.18-2.24C597,444.37,562.38,453,562.38,453Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#535461"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M554.62,510l23.26,59.75L598,604.46s27.59,61.34,25.77,73.2l44-7.07s-34.21-94-43.78-106.72c0,0-10-5.93-9.58-16l-12.31-59.75s12-11.56,5.28-26q-.51-1.11-1.18-2.24C597,444.37,562.38,453,562.38,453Z",
    transform: "translate(-122.5 -109.75)",
    opacity: 0.03
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M623.95,563.87s-10-5.93-9.58-16l-12.31-59.75s12-11.56,5.28-26q-.51-1.11-1.18-2.24c-4.42-7.52-14.86-9.36-24.43-9.25,9.18.08,18.84,2.09,23.06,9.25q.67,1.13,1.18,2.24c6.69,14.48-5.28,26-5.28,26L613,547.9c-.46,10,9.58,16,9.58,16,9.58,12.77,43.78,106.72,43.78,106.72l-42.62,6.85c0,.07,0,.15,0,.22l44-7.07S633.53,576.64,623.95,563.87Z",
    transform: "translate(-122.5 -109.75)"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M473.9,661.47s-18.24,15.51-36,16c0,0-31-.91-22.35,5.93s85.74,16.88,85.74,16.88l3.43-26.69Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#333"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M540.94,449.39s-30.1,42.42-42,85.29c0,0-10.49,18.24-9.12,36.94L470.7,664.21l35.12,13.23s-1.82-11.4,5-17.79,22.8-71.15,21.44-81.18c0,0,21.89-54.73,43.78-76.17s32.79-26.38,36-44.89C612.06,457.41,560.55,432.51,540.94,449.39Z",
    transform: "translate(-122.5 -109.75)"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M540,449.39s-30.1,42.42-42,85.29c0,0-10.49,18.24-9.12,36.94l-19.16,92.59,35.12,13.23s-1.82-11.4,5-17.79,22.8-71.15,21.44-81.18c0,0,21.89-54.73,43.78-76.17s32.79-26.38,36-44.89C611.15,457.41,559.64,432.51,540,449.39Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#535461"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.47,443.07c22.61.27,50.77,13.88,50.77,13.88-3.22,18.51-14.11,23.45-36,44.89S530.45,578,530.45,578c1.37,10-14.59,74.8-21.44,81.18-6,5.56-5.34,14.91-5.09,17.25l1.44.54s-1.82-11.4,5-17.79S533.19,588,531.82,578c0,0,21.89-54.73,43.78-76.17s32.79-26.38,36-44.89C611.61,457,582.29,442.79,559.47,443.07Z",
    transform: "translate(-122.5 -109.75)"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M517.68,383.26s-21.77,27.11-36.46,33a34.69,34.69,0,0,0-4.68,2.3,18.89,18.89,0,0,1-6.72,2.63,16.47,16.47,0,0,0-5.09,1.34c-7.64,3.52-25.26,13-13.63,21.4,14.59,10.49,34.21-13.68,34.21-13.68s8.33-5.22,13.23-6.39S525.89,407,525.89,407Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#fda57d"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "399.28 268.03 390.62 275.79 403.39 291.75 399.28 268.03",
    fill: "#4d8af0"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "399.28 268.03 390.62 275.79 403.39 291.75 399.28 268.03"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M543.74,287s-20.76,17.79-12.07,22.8l-14,34.66,4.83,126.79,19.79-32.84-13.52-71.15s-3.86-42.42,7.24-52.45l10.62-21Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#4d8af0"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M547.39,287s-20.76,17.79-12.07,22.8l-14,34.66,4.83,126.79,19.79-32.84-13.52-71.15s-3.86-42.42,7.24-52.45l10.62-21Z",
    transform: "translate(-122.5 -109.75)"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M527.71,268.32s16.88,20.52,16.42,32.38,31.93-20.52,31.93-20.52-12.31-15.05-9.12-31S527.71,268.32,527.71,268.32Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#fda57d"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M623.95,371.4l4.56,36.49v36s-6.39,46.52,13.68,37.86,5.47-40.59,5.47-40.59,0-17.79,2.74-26.91S649,365,649,365Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#fda57d"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M561.46,285.2s-12.31,11.86-18.7,7.75L534,314.72a100,100,0,0,0-7.12,41.94L530,438.9l13.68-1.82,4.56-78,6.84-47.43Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#f2f2f2"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571.73,272.66S555.53,283.83,551,293.41c0,0-.46,10.49-4.1,15.05s-7.3,27.37-8.21,54.73-5,63.85-5,63.85-6.84,35.57-14.14,39.22c0,0,33.75-25.54,50.17-16.88s35.12,29.65,40.59,26.45c0,0-1.32-40,4.67-61.29q.17-.61.35-1.19c6.39-21,2.28-49.71,9.58-62,0,0,0-22.29-4.21-38.94a30.09,30.09,0,0,0-16.1-19.65l-20.28-9.82S573.55,281.32,571.73,272.66Z",
    transform: "translate(-122.5 -109.75)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571.73,272.66s-15.28,12.09-19.84,21.66c0,0-.46,10.49-4.1,15.05s-7.3,27.37-8.21,54.73-5,63.85-5,63.85-6.84,35.57-14.14,39.22c0,0,33.75-25.54,50.17-16.88s35.12,29.65,40.59,26.45c0,0-1.32-40,4.67-61.29q.17-.61.35-1.19c6.39-21,2.28-49.71,9.58-62,0,0,0-22.29-4.21-38.94a30.09,30.09,0,0,0-16.1-19.65l-20.28-9.82S573.55,281.32,571.73,272.66Z",
    transform: "translate(-122.5 -109.75)"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M571.5,272.43s-15.05,11.4-19.61,21c0,0-.46,10.49-4.1,15.05s-7.3,27.37-8.21,54.73-5,63.85-5,63.85-6.84,35.57-14.14,39.22c0,0,33.75-25.54,50.17-16.88S605.7,479,611.18,475.84c0,0-1.32-40,4.67-61.29q.17-.61.35-1.19c6.39-21,2.28-49.71,9.58-62,0,0,0-22.29-4.21-38.94a30.09,30.09,0,0,0-16.1-19.65l-20.28-9.82S574.92,280.41,571.5,272.43Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#4d8af0"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M613.23,299.11s46.29,52.68,39.91,77.76c0,0-23.72-5.47-30.1,1.82,0,0-5-16.88-20.07-26.45S574,281.32,613.23,299.11Z",
    transform: "translate(-122.5 -109.75)"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M613.23,298.2s46.29,52.68,39.91,77.76c0,0-23.72-5.47-30.1,1.82,0,0-5-16.88-20.07-26.45S574,280.41,613.23,298.2Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#4d8af0"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.08,259.43c-.72-3.68-.12-4,.68-8,3.19-16-39.22,19.16-39.22,19.16s2.36,2.87,5.29,7.09a32.52,32.52,0,0,0,6.57.67C553,278.36,562.35,268.57,568.08,259.43Z",
    transform: "translate(-122.5 -109.75)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 417.07,
    cy: 133.94,
    r: 32.38,
    fill: "#fda57d"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M510.48,234.83c-4.77.64-10.85-1-11.77-5.67-1.16-6,6.82-9.85,8.06-15.81.46-2.24-.09-4.57.18-6.83.54-4.57,4.23-8.08,8-10.74a61.41,61.41,0,0,1,40.84-10.88,9.17,9.17,0,0,1,5.06,1.6c1.57,1.29,2.18,3.39,3.25,5.12,3.7,6,12,6.67,17.94,10.39,7,4.35,10.41,12.89,10.72,21.09s-2,16.25-4.35,24.13c-2,6.7-4,13.58-8.36,19.06s-11.49,9.32-18.28,7.67c3.11-2.24.85-7.44-2.52-9.27s-7.55-2.14-10.43-4.66-3.74-6.64-4.68-10.39c-1.18-4.73-2.9-9.53-6.35-13C531,229.89,518.79,233.71,510.48,234.83Z",
    transform: "translate(-122.5 -109.75)"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M511.39,234.38c-4.77.64-10.85-1-11.77-5.67-1.16-6,6.82-9.85,8.06-15.81.46-2.24-.09-4.57.18-6.83.54-4.57,4.23-8.08,8-10.74a61.41,61.41,0,0,1,40.84-10.88,9.17,9.17,0,0,1,5.06,1.6c1.57,1.29,2.18,3.39,3.25,5.12,3.7,6,12,6.67,17.94,10.39,7,4.35,10.41,12.89,10.72,21.09s-2,16.25-4.35,24.13c-2,6.7-4,13.58-8.36,19.06s-11.49,9.32-18.28,7.67c3.11-2.24.85-7.44-2.52-9.27s-7.55-2.14-10.43-4.66S546,252.94,545,249.19c-1.18-4.73-2.9-9.53-6.35-13C531.92,229.43,519.7,233.26,511.39,234.38Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#72351c"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M559.12,201.52l2.93-15a1.11,1.11,0,0,0-.88-1.31l-10.35-2a1.11,1.11,0,0,0-1.31.88l-2.93,15-10,37.08,18.35,3.58Z",
    transform: "translate(-122.5 -109.75)",
    fill: "#cbdae3"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 421.4,
    cy: 134.63,
    r: 15.96
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 421.4,
    cy: 135.08,
    r: 15.96,
    fill: "#cbdae3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 421.4,
    cy: 135.08,
    r: 10.46,
    fill: "#e9e9e9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 421.4,
    cy: 135.08,
    r: 3.19,
    fill: "#f48681"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 546.68,
    y: 198.95,
    width: 12.77,
    height: 0.46,
    transform: "translate(-74.06 -212.08) rotate(11.05)",
    opacity: 0.05
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 454.15,
    y: 414.9,
    width: 15.51,
    height: 37.86,
    rx: 7.75,
    ry: 7.75,
    transform: "translate(-265.09 133.94) rotate(-25.74)",
    fill: "#cbdae3"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 454.15,
    y: 414.9,
    width: 15.51,
    height: 37.86,
    rx: 7.75,
    ry: 7.75,
    transform: "translate(-265.09 133.94) rotate(-25.74)"
  }))), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 455.36,
    y: 414.2,
    width: 15.96,
    height: 37.86,
    rx: 7.98,
    ry: 7.98,
    transform: "translate(-264.64 134.5) rotate(-25.74)",
    fill: "#cbdae3"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 456.51,
    y: 417.12,
    width: 12.06,
    height: 28.73,
    transform: "translate(-264.01 133.99) rotate(-25.74)",
    fill: "#f2f2f2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 470.38,
    cy: 447.2,
    rx: 1.37,
    ry: 1.82,
    transform: "translate(-270.06 138.96) rotate(-25.74)",
    fill: "#f2f2f2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideimg2);
export default __webpack_public_path__ + "static/media/sideimg2.9284f53cbe71a5dac4485b6a910b90ef.svg";
export { ForwardRef as ReactComponent };